<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل مدير</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/managerview">مديرين الموقع</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل مدير</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="me-2 text-brown">
              <i class="bi bi-pencil-square mx-2 text-brown"></i>عرض البيانات
            </h5>
            <div class="card">
              <div v-if="successfuly" class="pt-3 text-center">
                <successAlert :message= "message" />
              </div>
              <div class="card-body">
                <errorAlert v-if="adminError" :alertMessage= "message" />
                <div class="row py-2">
                  <div class="col">
                    <label for="">الاسم</label>
                    <div>{{ adminName }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label for="">البريد الإلكتروني</label>
                    <div>{{ email }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label for="">يمتلك جميع الصلاحيات (Super User)</label>
                    <div>{{ (isAdmin)? 'نعم' : 'لا' }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col-md-6">
                    <label>مسؤول تعميد</label>
                    <div>{{ isApprovalOfficer ? 'نعم' : 'لا' }}</div>
                  </div>
                  <div class="col-md-6">
                    <label>موظف تنفيذي</label>
                    <div>{{ isExecutiveEmployee ? 'نعم' : 'لا' }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label for="">المجموعات</label>
                    <div v-for="g in currentGroups" :key="g.id">{{ g.name }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label for="">الحاله</label>
                    <div>{{ (status)? 'نشط' : 'غير نشط' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name:'managerRead',
  data(){
    return {
      Admin_Id: this.$route.params.id,
      loader: false,
      adminError: false,
      message: '',
      adminName: "",
      isLoading: false,
      status: true,
      successfuly: false,
      email: "",
      password: "",
      isAdmin: true,
      groups: [],
      groupsList: [],
      currentGroups: [],
      isApprovalOfficer: false,
      isExecutiveEmployee: false,
    }
  },
  methods:{
    getData() {
      this.loader = true;
      this.$http.get(`/api/admin/admins/retrieve/${this.Admin_Id}`).then(res => {
        // console.log(res);
        this.adminName = res.data.admin.name;
        this.status = res.data.admin.isActive;
        this.email = res.data.admin.email;
        this.isAdmin = res.data.admin.isSuperUser;
        this.isApprovalOfficer = !!res.data.admin.isApprovalOfficer;
        this.isExecutiveEmployee = !!res.data.admin.isExecutiveEmployee;
        this.groupsList = res.data.groups;
        this.currentGroups = res.data.admin.Groups ?? [];
        if(res.data.admin.Groups){
          for(let i=0; i<res.data.admin.Groups.length; i++){
            this.groups.push(res.data.admin.Groups[i].id);
          }
        }
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.adminError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
  },
  created() {
    this.getData();
  }
}
</script>